import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-deanrd',
  templateUrl: './deanrd.component.html',
  styleUrls: ['./deanrd.component.scss']
})
export class DeanrdComponent implements OnInit {

  constructor() { }

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }

}
